import { render, staticRenderFns } from "./AllDownload.vue?vue&type=template&id=968edb3a&scoped=true"
import script from "./AllDownload.vue?vue&type=script&lang=js"
export * from "./AllDownload.vue?vue&type=script&lang=js"
import style0 from "./AllDownload.vue?vue&type=style&index=0&id=968edb3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "968edb3a",
  null
  
)

export default component.exports